import { styled, SvgIconProps } from "@mui/material";
import AzureDevOpsLogo from "../svg/devops-logo.svg?react";

const AzureDevOpsIconSvg = styled(AzureDevOpsLogo)`
  & > path {
    fill: currentcolor;
  }
`;

const AzureDevOpsIcon = (props: SvgIconProps) => {
  return <AzureDevOpsIconSvg {...props} />;
};

export { AzureDevOpsIcon };
